import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const toggle = () => {
    const newLang = isArabic ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  };

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 text-xs font-light text-muted-foreground hover:text-foreground transition-colors tracking-wide"
      aria-label="Switch language"
    >
      <Globe size={14} strokeWidth={1.5} />
      <span>{isArabic ? "EN" : "عربي"}</span>
    </button>
  );
};

export default LanguageSwitcher;
